import { render, staticRenderFns } from "./V2CollectionProducts.vue?vue&type=template&id=5bf8c3bb&scoped=true&"
import script from "./V2CollectionProducts.vue?vue&type=script&lang=js&"
export * from "./V2CollectionProducts.vue?vue&type=script&lang=js&"
import style0 from "./V2CollectionProducts.vue?vue&type=style&index=0&id=5bf8c3bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf8c3bb",
  null
  
)

export default component.exports